module.exports = __webpack_public_path__ + "static/media/44.f49c9a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/44.png
// module id = 468
// module chunks = 0